import { React, useEffect, useState, useRef, useCallback } from 'react';
import { useNavigate } from "react-router-dom";
import { Row, Col } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import { useTranslation } from "react-i18next";
import { motion } from 'framer-motion';
import "./index.scss";

import ProfileAvatar from '../../../ui/ProfileAvatar';
import CheckBox from "../../../ui/CheckBox";
import Button from "../../../ui/Button";
import Pagination from "../../../ui/Pagination";
import NoDataFound from "../../../ui/NoDataFound";
import DropDown from "../../../ui/DropDown";
import RadioButton from "../../../ui/RadioButton";
import SkeletonLoader from "../../../ui/SkeletonLoader";
import SideModal from "../../../ui/SideModal";

import DownloadReport from "../../ScanInfo/Reports/DownloadReport";

import { deleteIcon, sendIcon, filterIcon, filterCloseIcon, scanHistoryDownloadReportIcon, searchIcon } from "../../../../utils/icons";
import { formatDate, getDomainImageUrl, getUserImageUrl } from "../../../../utils/util";

import { useSelector, useDispatch } from 'react-redux';
import { getScanHistory, resetScanHistoryList } from '../../../../store/actions/domainAction';


const scanTypeOption = [
    {
        label: "Active",
        value: "active"
    },
    {
        label: "Passive",
        value: "passive"
    }
]

const monitorScanOption = [
    {
        label: "Auto Scan",
        value: "auto"
    },
    {
        label: "Ad-hoc Scan",
        value: "ad-hoc"
    }
]

const sortByOption = [
    {
        label: "Domain",
        value: "domain"
    },
    {
        label: "Created At",
        value: "created_at"
    },
]

const filterRadioOption = [    
    {
        label: "Ascending",
        value: "asc"
    },
    {
        label: "Descending",
        value: "desc"
    }
]


const ScanHistoryTab = ({scanHistoryData, currentPageType}) => {

    const scanHistoryListResponse = useSelector((state) => state?.domain.scanHistoryList)

    const { t } = useTranslation();

    const navigate = useNavigate();

    const filterWrapperRef = useRef(null);

    const dispatch = useDispatch();

    const [scanHistorySearchValue, setScanHistorySearchValue] = useState("");
    const [searchedScanHistoryValue, SetSearchedScanHistoryValue] = useState("")
    const [isScanSearchFocused, setIsScanSearchFocused] = useState(false);
    //filter value
    const [showFilter, setShowFilter] = useState(false);
    const [selectedSortby, setSelectedSortby] = useState("");
    const [selectedSortOrder, setSelectedSortOrder] = useState("");
    const [selectedScanType, setSelectedScanType] = useState("");
    const [selectedMonitorType, setSelectedMonitorType] = useState("");

    //selected filter value
    const [filterSelectedSortby, setFilterSelectedSortby] = useState("");
    const [filterSelectedSortOrder, setFilterSelectedSortOrder] = useState("");
    const [filterSelectedScanType, setFilterSelectedScanType] = useState("");
    const [filterSelectedMonitorType, setFilterSelectedMonitorType] = useState("");

    const [filterList, setFilterList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedDomain, setSelectedDoamin] = useState("");
    const [showDownloadReport, setShowDownloadReport] = useState(false);

    const [scanHistoryList, setScanHistoryList] = useState(null)

    const closeAddOrgSidePanel = () => {
        setShowDownloadReport(false)
    }

    const setCheckboxvalue = (e) => {
        if(e.target.checked) {
            setFilterList([...filterList, e.target.value])
        } else {
            removeFilter(e.target.value)
        }
    }

    const removeFilter = (type) => {
        setCurrentPage(1);
        if (type === "scanType") {
            setSelectedScanType("")
            setFilterSelectedScanType("")
        } else if(type === "monitorType") {
            setSelectedMonitorType("")
            setFilterSelectedMonitorType("")
        } else if (type === "sortOrder") {
            setSelectedSortOrder("")
            setFilterSelectedSortOrder("")
        } else {
            setSelectedSortby("")
            setSelectedSortOrder("")
            setFilterSelectedSortby("")
            setFilterSelectedSortOrder("")
        }
    }

    const applyFilter = () => {
        setCurrentPage(1);
        setShowFilter(false)
        setFilterSelectedSortby(selectedSortby);
        setFilterSelectedSortOrder(selectedSortOrder);
        setFilterSelectedScanType(selectedScanType);
        setFilterSelectedMonitorType(selectedMonitorType);
    }

    const filterClicked = () => {
        setShowFilter(true)
    }

    const handleSearchKeyDown = (event) => {
        if (event.key === "Enter" && isScanSearchFocused) {
            searchScanHistory()
        }
    }

    const searchScanHistory = () => {
        setCurrentPage(1);
        SetSearchedScanHistoryValue(scanHistorySearchValue)
    }

    const sortOrderChange = (data) => {
        setSelectedSortOrder(data)
    }

    const displaySortByName = (type) => {
        if (type === "scanType") {
            const matchedOption = scanTypeOption.find((data) => data.value === selectedScanType)
            return matchedOption ? matchedOption.label : "";
        } else if(type === "monitorType") {
            const matchedOption = monitorScanOption.find((data) => data.value === selectedMonitorType)
            return matchedOption ? matchedOption.label : "";
        } else if (type === "sortOrder") {
            const matchedOption = filterRadioOption.find((data) => data.value === selectedSortOrder)
            return matchedOption ? matchedOption.label : "";
        } else {
            const matchedOption = sortByOption.find((data) => data.value === selectedSortby)
            return matchedOption ? matchedOption.label : "";
        }
    }

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const fetchScanHistory = useCallback(()=>{
        if(currentPageType === "domainDetails" || currentPageType === "monitorDetails") {
            setIsLoading(true)
            let domain = currentPageType === "domainDetails" ? scanHistoryData?.domain : scanHistoryData?.monitor_domain.domain
            const baseUrl = `&page=${currentPage}&page_size=${currentPageSize}&domain=${domain}`;
            const queryParams = searchedScanHistoryValue ? `&query=${searchedScanHistoryValue}` : ""
            const sortParams = (filterSelectedScanType ? `&scan_type=${filterSelectedScanType}` : '') + (filterSelectedMonitorType ? `&monitor_scan=${filterSelectedMonitorType === "auto" ? true : false }` : "") + (filterSelectedSortby ? `&sort_by=${filterSelectedSortby}` : '') + (filterSelectedSortOrder ? `&sort_order=${filterSelectedSortOrder}` : '');
            const url = `${baseUrl}${queryParams}${sortParams}`;
            if(currentPageType === "domainDetails" && scanHistoryData?.domain) {
                dispatch(getScanHistory(url));
            } else if(currentPageType === "monitorDetails" && scanHistoryData?.monitor_domain.domain) {
                dispatch(getScanHistory(url));
            }
        } else if(currentPageType === "usersDetails") {
            setIsLoading(true)
            const baseUrl = `&page=${currentPage}&page_size=${currentPageSize}&user_id=${scanHistoryData?.user_id}`;
            const queryParams = searchedScanHistoryValue ? `&query=${searchedScanHistoryValue}` : ""
            const sortParams = (filterSelectedScanType ? `&scan_type=${filterSelectedScanType}` : '') + (filterSelectedMonitorType ? `&monitor_scan=${filterSelectedMonitorType === "auto" ? true : false }` : "") + (filterSelectedSortby ? `&sort_by=${filterSelectedSortby}` : '') + (filterSelectedSortOrder ? `&sort_order=${filterSelectedSortOrder}` : '');
            const url = `${baseUrl}${queryParams}${sortParams}`;
            if(scanHistoryData?.user_id) {
                dispatch(getScanHistory(url));
            }
        } else if(currentPageType === "scanHistoryPage") {
            setIsLoading(true)
            const baseUrl = `&page=${currentPage}&page_size=${currentPageSize}`;
            const queryParams = searchedScanHistoryValue ? `&query=${searchedScanHistoryValue}` : ""
            const sortParams = (filterSelectedScanType ? `&scan_type=${filterSelectedScanType}` : '') + (filterSelectedMonitorType ? `&monitor_scan=${filterSelectedMonitorType === "auto" ? true : false }` : "") + (filterSelectedSortby ? `&sort_by=${filterSelectedSortby}` : '') + (filterSelectedSortOrder ? `&sort_order=${filterSelectedSortOrder}` : '');
            const url = `${baseUrl}${queryParams}${sortParams}`;
            dispatch(getScanHistory(url));
        }     
    },[currentPageType, currentPage, currentPageSize, scanHistoryData, dispatch, searchedScanHistoryValue, filterSelectedScanType, filterSelectedMonitorType, filterSelectedSortby, filterSelectedSortOrder])

    const getScoreStatus = (data) => {
        const score = data?.stats?.score?.overall_score?.obtained_score;
        if (score == null) return undefined;
        if (score >= 800) return 'low';
        if (score >= 500) return 'medium';
        if (score >= 250) return 'high';
        return 'critical';
    }

    useEffect(()=>{
        document.addEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event) {
            if (filterWrapperRef.current && !filterWrapperRef.current.contains(event.target)) {
                if(showFilter){
                    setShowFilter(false)
                    setFilterList([])
                }
            }        
        }
    },[showFilter,filterList])    

    useEffect(()=>{
        setIsLoading(true)
        fetchScanHistory()
    },[fetchScanHistory]);

    useEffect(()=>{
        if(scanHistoryListResponse !== null) {
            setIsLoading(false)
            setScanHistoryList(scanHistoryListResponse)
            dispatch(resetScanHistoryList());
        }
    },[scanHistoryListResponse, dispatch])


    return (
        <Row>
            <Col md={12}>
                <div className="search-filter-container my-3 d-flex justify-content-between align-items-center">
                    <div className="search-container d-flex align-items-center gap-3">
                        <div className="position-relative" onKeyDown={handleSearchKeyDown}>
                            <input className="search-input rounded" 
                                placeholder="Search Scan history" 
                                value={scanHistorySearchValue} 
                                onChange={(e)=>setScanHistorySearchValue(e.target.value)}
                                onFocus={() => setIsScanSearchFocused(true)}
                                onBlur={() => setIsScanSearchFocused(false)}
                            />
                            <span className="position-absolute search-icon">{searchIcon()}</span>
                        </div>
                        <button className="search-btn" onClick={searchScanHistory}>Search</button>
                        <div className="position-relative">
                            <span className="filter-icon" onClick={filterClicked}>{filterIcon()}</span>
                            {showFilter && <div className="filters-container position-absolute p-3 rounded" ref={filterWrapperRef}>
                                <h6>Scan Type</h6>
                                <DropDown 
                                    placeHolder={"Sort By"}
                                    options={scanTypeOption}
                                    isMulti={false}
                                    isSearchable={false}
                                    onChange={(data)=>{setSelectedScanType(data.value)}}
                                    defaultSelectedValue={selectedScanType}
                                />
                                <h6 className="mt-4">Monitor Type</h6>
                                <DropDown 
                                    placeHolder={"Sort By"}
                                    options={monitorScanOption}
                                    isMulti={false}
                                    isSearchable={false}
                                    onChange={(data)=>{setSelectedMonitorType(data.value)}}
                                    defaultSelectedValue={selectedMonitorType}
                                />
                                <h6 className="mt-4">{t("organizationDetailsPage.usersTable.sortBy")}</h6>
                                <DropDown 
                                    placeHolder={"Sort By"}
                                    options={sortByOption}
                                    isMulti={false}
                                    isSearchable={false}
                                    onChange={(data)=>{setSelectedSortby(data.value)}}
                                    defaultSelectedValue={selectedSortby}
                                />
                                <h6 className="mt-4">Sort Order</h6>
                                <div className="filter-user-status d-flex mb-4 gap-4">
                                    {
                                        filterRadioOption.map((data,index)=>{
                                            return (
                                                <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={sortOrderChange} key={index} isChecked={data.value === selectedSortOrder} />
                                            )
                                        })
                                    }
                                </div>
                                <div className="filter-apply-btn mt-3">
                                    <Button buttonText={"Apply"}  buttonType={"primary"} disableButton={false} buttonClicked={applyFilter}/>
                                </div>
                            </div>}
                        </div>
                        {!showFilter && <p className="selected-filters">
                            {filterSelectedScanType !== "" && <span className="d-inline-block mx-2">{displaySortByName("scanType")} <span onClick={() => removeFilter("scanType")}>{filterCloseIcon()}</span></span>}
                            {filterSelectedMonitorType !== "" && <span className="d-inline-block mx-2">{displaySortByName("monitorType")} <span onClick={() => removeFilter("monitorType")}>{filterCloseIcon()}</span></span>}
                            {filterSelectedSortby !== "" && <span className="d-inline-block mx-2">{displaySortByName("sortby")} <span onClick={() => removeFilter("sortby")}>{filterCloseIcon()}</span></span>}
                            {filterSelectedSortOrder !== "" && <span className="d-inline-block mx-2">{displaySortByName("sortOrder")} <span onClick={() => removeFilter("sortOrder")}>{filterCloseIcon()}</span></span>}
                        </p>}
                    </div>
                    <div className="sort-edit-container">
                        <div className="container d-flex gap-3 align-items-center">
                            {/* <button onClick={()=>{setShowModifySidePanel(true)}}>
                                <img src={editIcon} alt="edit" className="d-inline-block mx-1" />
                                Delete
                            </button> */}
                            <button className="edit-btn" disabled>
                                <p className="d-inline-block mx-1">{deleteIcon()}</p>
                                {t('scanHistoryPage.delete')}
                            </button>
                        </div>
                    </div>
                </div>
                <div className="domain-table-container user-page-scanHistory-table">
                    {isLoading ?
                        <SkeletonLoader type={"line"} count={5} currentPage={"scanHistory"} />
                        :
                            <Table responsive="lg">
                                <thead>
                                    <tr>
                                        <th className="org-tabel-select-all"><CheckBox checkBoxId={2} checkBoxValue={"select all"} handleCheckboxChange={setCheckboxvalue} /></th>
                                        <th>{t('scanHistoryPage.domainDetails')}</th>
                                        <th>{t('scanHistoryPage.date')}</th>
                                        <th>{t('scanHistoryPage.scannedDetails')}</th>
                                        <th>{t('scanHistoryPage.scanType')}</th>
                                        <th>{t('scanHistoryPage.score')}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>                            
                                    {
                                        scanHistoryList?.results.length > 0 &&
                                        scanHistoryList.results.map((data, index)=>{
                                            return (
                                                <motion.tr
                                                    key={index}
                                                    initial={{ opacity: 0, y: 20 }}
                                                    // whileInView={{ opacity: 1, y: 0 }}
                                                    // viewport={{ once: true }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{ duration: 0.4, delay: index * 0.1 }}
                                                >
                                                    <td>
                                                        <CheckBox checkBoxId={1} checkBoxValue={"1"} handleCheckboxChange={setCheckboxvalue}/>
                                                    </td>
                                                    <td>
                                                        <ProfileAvatar type="domain" name={data?.domain} imageUrl={getDomainImageUrl(data)} />
                                                    </td>
                                                    <td className="vertical-align">
                                                        {data?.created_at !== null && <p className="date-details">
                                                            <span className="label">{t('scanHistoryPage.scanCreated')}</span>
                                                            <span className="value">{formatDate(data?.created_at)}</span>
                                                        </p>}
                                                        {data?.scan_initiated_on !== null && <p className="date-details mt-1">
                                                            <span className="label">{t('scanHistoryPage.scanInitiated')}</span>
                                                            <span className="value">{formatDate(data?.scan_initiated_on)}</span>
                                                        </p>}
                                                        {data?.scan_completed_on !== null && <p className="date-details mt-1">
                                                            <span className="label">{t('scanHistoryPage.scanCompleted')}</span>
                                                            <span className="value">{formatDate(data?.scan_completed_on)}</span>
                                                        </p>}
                                                    </td>
                                                    <td>
                                                        <div className="scan-details">
                                                            <ProfileAvatar type="profile" firstName={data?.created_by.name} lastName={""} secondaryText={data?.created_by?.role} imageUrl={getUserImageUrl(data?.created_by)} />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <p className={`scan-type ${data.scan_type === "active" ? 'active' : 'passive'}`}>{data.scan_type}</p>
                                                    </td>
                                                    <td>
                                                        <span className={getScoreStatus(data)}>{data?.stats?.score?.overall_score?.obtained_score}</span> / {data?.stats?.score?.overall_score?.max_score}
                                                    </td>
                                                    <td>
                                                        <div className="d-flex align-items-center gap-2 scan-history-action">
                                                            <p className="view-scan" onClick={()=>{
                                                                navigate(`/scan-info/exposure/dashboard?customer=all&organization=all&domain=${data?.domain}&scanId=${data?.scan_id}`)
                                                            }}>{t('scanHistoryPage.viewScan')}{sendIcon()}</p>
                                                            <p className="scan-border"></p>
                                                            <span className="scan-history-download" onClick={()=>{
                                                                setSelectedDoamin(data)
                                                                setShowDownloadReport(true)
                                                            }}>{scanHistoryDownloadReportIcon()}</span>
                                                        </div>
                                                    </td>
                                                </motion.tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>
                    }
                    {
                        !isLoading && scanHistoryList?.results.length === 0 && 
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4 }}
                        >
                            <NoDataFound />
                        </motion.div>
                        
                    }
                    {scanHistoryList !== null && !isLoading && scanHistoryList?.meta?.total_results !== 0 && <Pagination
                        className="pagination-bar"
                        currentPage={currentPage}
                        pageSize={currentPageSize}
                        totalCount={scanHistoryList?.meta?.total_results}
                        onPageChange={setCurrentPageandRecordSize}
                    />}
                </div>
                <SideModal showSidePanel={showDownloadReport} hideSidePanel={closeAddOrgSidePanel}>
                    {showDownloadReport && <DownloadReport currentPageType={"scanHistory"} domainDetails={selectedDomain} closeDownloadReport={closeAddOrgSidePanel}/>}
                </SideModal>
            </Col>
        </Row>
    )
}

export default ScanHistoryTab;